import '../Footer/footer.css';

const Footer = () => {
  return (
    <footer className='footer-container'>
      <h4 className='footer-h-styles'>&#169; Jordy Peña</h4>
    </footer>
  )
}
export default Footer;